// extracted by mini-css-extract-plugin
export default {"container":"projects_container__tqwtf","row":"projects_row__K4rcF","title":"projects_title__fVe1I","link":"projects_link__HiMBE","description":"projects_description__ySpvt"};